import {lazy} from 'react';

export const CookieWriterLazy = lazy(() => import(/* webpackChunkName: "cookieWriter" */ '.'));
